import React from 'react';
const SmallCircleLoader = ({ color = "#3498db" }) => {
  return (
    <>
      <style>
        {`
          .css-loader {
            border: 2px solid #f3f3f3;
            border-top: 2px solid ${color};
            border-radius: 50%;
            width: 16px;
            height: 16px;
            animation: spin 0.8s linear infinite;
            display: inline-block;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div className="css-loader"></div>
    </>
  );
};

export default SmallCircleLoader;